module.exports = __webpack_public_path__ + "img/35.cfba1ab0.svg";